import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getBusinessGroupUserDatatable,
  createNewBusinessGroupUser,
  setBusinessGroupUserRole,
  getBusinessGroupUserDatatableExported,
  unlinkBusinessGroupUser,
  createNewBusinessGroupAdmin,
} from './thunks';
import { businessGroupsUsersState } from './types';

export const name = 'BusinessGroupUsers';

const initialState: businessGroupsUsersState = {
  data: null,
  status: 'idle',
  datatableExported: {
    data: null,
    status: 'idle',
  },
  unlinkBusinessGroupUser: {
    data: null,
    status: 'idle',
  },
  create: {
    status: 'idle',
  },
  createAdmin: {
    data: null,
    status: 'idle',
  },
};

export const getBusinessGroupUserDatatableAsync = createAsyncThunk(
  name + '/getBusinessGroupUserDatatable',
  getBusinessGroupUserDatatable
);

export const getBusinessGroupUserDatatableExportedAsync = createAsyncThunk(
  name + '/getBusinessGroupUserDatatableExported',
  getBusinessGroupUserDatatableExported
);

export const createNewBusinessGroupUserAsync = createAsyncThunk(
  name + '/createNewBusinessGroupUser',
  createNewBusinessGroupUser
);

export const createNewBusinessGroupAdminAsync = createAsyncThunk(
  name + '/createNewBusinessGroupAdmin',
  createNewBusinessGroupAdmin
);

export const setBusinessGroupUserRoleAsync = createAsyncThunk(
  name + '/setBusinessGroupUserRole',
  setBusinessGroupUserRole
);

export const unlinkBusinessGroupUserAsync = createAsyncThunk(
  name + '/unlinkBusinessGroupUser',
  unlinkBusinessGroupUser
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessGroupUserDatatableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        getBusinessGroupUserDatatableAsync.fulfilled,
        (state, action) => {
          state.status = 'idle';
          state.data = action.payload;
        }
      )
      .addCase(getBusinessGroupUserDatatableAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getBusinessGroupUserDatatableExportedAsync.pending, (state) => {
        state.datatableExported.status = 'loading';
      })
      .addCase(
        getBusinessGroupUserDatatableExportedAsync.fulfilled,
        (state, action) => {
          state.datatableExported = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(
        getBusinessGroupUserDatatableExportedAsync.rejected,
        (state, action) => {
          state.datatableExported.status = 'failed';
        }
      )
      .addCase(unlinkBusinessGroupUserAsync.pending, (state) => {
        state.unlinkBusinessGroupUser.status = 'loading';
      })
      .addCase(unlinkBusinessGroupUserAsync.fulfilled, (state, action) => {
        state.unlinkBusinessGroupUser = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(unlinkBusinessGroupUserAsync.rejected, (state, action) => {
        state.unlinkBusinessGroupUser.status = 'failed';
      })
      .addCase(createNewBusinessGroupUserAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createNewBusinessGroupUserAsync.fulfilled, (state) => {
        state.create = {
          status: 'idle',
        };
      })
      .addCase(createNewBusinessGroupUserAsync.rejected, (state, action) => {
        state.create.status = 'failed';
      })
      .addCase(createNewBusinessGroupAdminAsync.pending, (state) => {
        state.createAdmin.status = 'loading';
      })
      .addCase(createNewBusinessGroupAdminAsync.fulfilled, (state, action) => {
        state.createAdmin = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createNewBusinessGroupAdminAsync.rejected, (state) => {
        state.createAdmin.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
